import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionOneImageBody, SectionOneImageDetails } from "types/api/blocks/sectionOneImage";

function useSectionOneImageApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionOneImage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionOneImageDetails> => {
        return get<PathParamsWithId, undefined, SectionOneImageDetails>({
            url: "/blocks/section-one-image/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionOneImage = React.useCallback((body: SectionOneImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionOneImageBody, null>({
            url: "/blocks/section-one-image",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionOneImage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-one-image/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionOneImage,
        saveSectionOneImage,
        deleteSectionOneImage
    };
}

export default useSectionOneImageApi;